<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        {{ this.$route.meta.title }}
        <div class="card-header-actions">
          <b-button variant="primary mr-1" @click="exportxls()"><i class="fa fa-file-excel-o"></i> Export</b-button>
        </div>
      </div>
      <b-row>
        <b-col>
          <b-input-group>
            <b-input-group-prepend>
              <label>Periode Trx.</label>
            </b-input-group-prepend>
            <b-form-select v-model="tblData.typeDate" :plain="true" :options="optionsTypeDate" style="max-width:190px;"></b-form-select>
            <b-input-group-prepend><span class="input-group-text">Date</span></b-input-group-prepend>
            <b-form-input v-model="tblData.tgl1" type="date"></b-form-input>
          </b-input-group>
          <!-- <b-input-group>
            <b-input-group-prepend>
              <label>Partner Transaction</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.partnerTransactionId" placeholder=""></b-form-input>
          </b-input-group> -->
        </b-col>
        <b-col>
          <b-input-group>
            <b-input-group-prepend>
              <label>Status</label>
            </b-input-group-prepend>
            <b-form-select v-model="tblData.statusDisbursement" :plain="true" :options="optStsDisbursement" disabled></b-form-select>
            <b-input-group-append>
              <b-button class="btn btn-success ml-3" @click="getData()">
                <i class="fa fa-refresh"></i> Apply
              </b-button>
            </b-input-group-append>
            <b-input-group-append>
              <b-button class="btn btn-secondary ml-1" @click="clearFilter()">
                <i class="fa fa-eraser"></i>Clear
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <b-table class="mb-0" ref="table" outlined responsive striped hover small style="font-size:smaller;" :items="tblData.items"
        :fields="tblFields" :current-page="tblData.page" :per-page="tblData.limit" :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc" :key="tblData.limit" :busy="isBusy" @row-clicked="rowClicked" show-empty>
        <template v-slot:cell(index)="data">{{ ((tblData.page - 1) * tblData.limit) + (data.index + 1) }}</template>
        <template v-slot:cell(disbursed_date)="data">{{ data.item.disbursed_date | moment("YYYY MMM DD") }}</template>
        <template v-slot:cell(loan_amount)="data">{{ data.item.loan_amount | numFormat('0,0.00') }}</template>
        <template v-slot:cell(upfont_lender_amount)="data">{{ data.item.upfont_lender_amount | numFormat('0,0.00') }}</template>
        <template v-slot:cell(upfont_other_amount)="data">{{ data.item.upfont_other_amount | numFormat('0,0.00') }}</template>
        <template v-slot:cell(net_disbursement)="data">{{ data.item.net_disbursement | numFormat('0,0.00') }}</template>
        <template v-slot:cell(interest_rate)="data">{{ data.item.interest_rate | numFormat('0,0.000') }}</template>
        <template v-slot:cell(tenor)="data">{{ data.item.tenor }} {{ data.item.tenorUnit }}</template>
                <template v-slot:cell(bank_disbursement_amount)="data">{{ data.item.bank_disbursement_amount | numFormat('0,0.00') }}</template>

        <template v-slot:cell(expectedDisbursementDate)="data">{{ data.item.expectedDisbursementDate | moment("YYYY MMM DD") }}</template>
        <template v-slot:cell(bank_disbursement_date)="data">{{ data.item.bank_disbursement_date | moment("YYYY MMM DD") }}</template>


        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
        <template v-slot:cell(empty)="data">
          <h4>{{ data.emptyText }}</h4>
        </template>
        <template v-slot:cell(emptyfiltered)="data">
          <h4>{{ data.emptyFilteredText }}</h4>
        </template>

        <template v-slot:custom-foot>
          <b-tr>
            <b-th colspan="4" class="text-center"><span class="">TOTAL</span></b-th>
            <b-th class="text-right"><span class="text-right">{{ tblData.loan_amount | numFormat('0,0.00') }}</span></b-th>
            <b-th class="text-right"><span class="text-right">{{ tblData.upfont_lender_amount | numFormat('0,0.00') }}</span></b-th>
            <b-th class="text-right"><span class="text-right">{{ tblData.upfont_other_amount | numFormat('0,0.00') }}</span></b-th>
            <b-th class="text-right"><span class="text-right">{{ tblData.net_disbursement | numFormat('0,0.00') }}</span></b-th>

          </b-tr>
        </template>


      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{ (tblData.page - 1) * tblData.limit + 1 }}
            to
            <span v-if="((tblData.page * tblData.limit) > tblData.total)">{{ tblData.total }}</span>
            <span v-else>{{ tblData.page * tblData.limit }}</span>
            of {{ tblData.total | numFormat }} entries
          </div>
        </b-col>
        <b-col cols="4">
          <b-form-group label-cols="3" label style="margin-top:0 !important;">
            <b-input-group>
              <b-input-group-prepend class="mr-2">
                <label>Limit per page</label>
              </b-input-group-prepend>
              <div class="d-flex">
                <b-form-select :options="[10, 15, 20, 25]" :plain="true" v-model="tblData.limit" size="sm"
                  style="width:80px" />
              </div>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-pagination align="right" :total-rows="tblData.total" :per-page="tblData.limit" v-model="tblData.page">
          </b-pagination>
        </b-col>
      </b-row>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
  </div>
</template>
  
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import dropdown from "../../data/dropdown";
import toastr from "mini-toastr";
import crud from "../../apis/crud";
import disbursement from "../../apis/disbursement";

toastr.init();
export default {
  components: { Loading },
  data() {
    return {
      showFilter: true,
      isBusy: false,
      isLoading: false,
      projectsFilt:[{
        value:'',text:'-- ALL --'
      }],
      optionsTypeDate:[{
        value:'expectedDisbursementDate',text:'Expected Disbursement',
      },
      {
        value:'disbursed_date',text:'Transaction'
      },
      {value:'bank_disbursement_date',text:'Bank Transaction'}
    ],
    optStsDisbursement:[
      {value:'CONFIRMED',text:'CONFIRMED'},
      {value:'CANCELLED',text:'CANCELLED'},
    ],    
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: "disbursementTransactionId",
        sortDesc: false,
        loan_amount: 0,
        upfont_lender_amount: 0,
        upfont_other_amount:0,
        net_disbursement:0,
        tgl1: moment().format('YYYY-MM-DD'),
        tgl2: moment().format('YYYY-MM-DD'),
        partnerTransactionId: '', loan_id: '',
        pjxkey:'',
        typeDate:'expectedDisbursementDate',
        // typeDate:'bank_disbursement_date',
        statusDisbursement:'CONFIRMED'
      },
      dataList: {
        debiturStatus: dropdown.debiturStatus
      },
    };
  },
  computed: {
    tblFields() {
      const fields = [
        {
          key: "index",
          label: "No.",
          thClass: "text-center",
          sortable: true
        },
        {
          key: "disbursed_date",
          label: "Disbursed Date",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true
        },
        {
          key: "loan_id",
          label: "Loan Id",
          thClass: "text-center",
          sortable: true
        },
        {
          key: "partnerTransactionId",
          label: "Partner Transaction Id",
          thClass: "text-center",
          sortable: true
        },
        {key:'loan_amount',label:'Loan Principal',thClass:"text-center",tdClass:"text-right",sortable:true},	
        {key:'upfont_lender_amount',label:'Upfront Lender',thClass:"text-center",tdClass:"text-right",sortable:true},	
        {key:'upfont_other_amount',label:'Upfront MGR',thClass:"text-center",tdClass:"text-right",sortable:true},	
        {key:'net_disbursement',label:'Net Disbursement',thClass:"text-center",tdClass:"text-right",sortable:true},	
        {key:'tenor',label:'Tenure',thClass:"text-center" ,thStyle: "min-width:100px",tdClass:"text-right",sortable:true},	
        {key:'interest_rate',label:'interestPerAnnum',thClass:"text-center",sortable:true},	
        {key:'applicationStatus',label:'applicationStatus',thClass:"text-center",sortable:true},	
        {key:'statusDisbursement',label:'statusDisbursement',thClass:"text-center",sortable:true},
        {
          key: "customerID",
          label: "Customer Id",
          thClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true
        },
        {
          key: "debtorFullName",
          label: "Customer Fullname",
          thClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true
        },
      {
        key: "expectedDisbursementDate",
        label:"Expected Disbursement Date",
      },
      {
        key: "bank_disbursement_date",
        label:"Bank Disbursement Date",
      },
      {
        key: "bank_disbursement_amount",
        label:"Bank Disbursement Amount",
        tdClass:"text-right"
      },
      ];
      return fields;
    },
  },
  async created() {

    const [projects] = await Promise.all([crud.list({
      tablename: 'project',
      page: 1,
      limit: 10000,
      total: 0,
      sortBy: 'pjxname',
      sortDesc: false,
    })]);

    projects.forEach(tp => {
      this.projectsFilt.push({ value: tp.pjxkey, text: tp.pjxname })
    });
    
    // if (this.$route) {
    //   if (this.$route.params) {
    //     const { tgl1, tgl2 } = this.$route.params;
    //     this.tblData.tgl1 = tgl1;
    //     this.tblData.tgl2 = tgl2;
    //   }
    //   if (this.$route.query) {
    //     const { tgl1, tgl2 } = this.$route.query;
    //     this.tblData.tgl1 = tgl1;
    //     this.tblData.tgl2 = tgl2;
    //   }
    // }
  },
  methods: {
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
        delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant = 'info';
      this.$forceUpdate();
      // }
    },
    async getData() {
      try {
        this.isBusy = true;
        const filter = this.$store.state.filter;
        let filtered = false;
        for (var key in filter.debiturList) {
          this.tblData[key] = filter.debiturList[key];
          filtered = true;
        }
        if (filtered === true) {
          this.showFilter = filtered;
          delete filter.debiturList;
          this.$store.commit("filter", filter);
        }
        this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
        if (this.tblData.tgl1 || this.tblData.tgl2) {
          if ((this.tblData.tgl2 || '') == '') {
            this.tblData.tgl2 = this.tblData.tgl1;
          }
        }
        this.tblData.loan_amount = 0;
        const list = await disbursement.listV2(this.tblData);
        this.tblData.items = list;
        this.tblData.total = list.length
        this.isBusy = false;
        
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    async exportxls() {
      try {
        this.isLoading = true;
        await disbursement.exportxlsV2(this.tblData);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    async refresh() {
      try {
        this.$refs.table.refresh();
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    clearFilter() {
      this.tblData.custinfo = "";
      this.tblData.nomoridentitas = "";
      this.tblData.alamatktp = "";
      this.tblData.npwp = "";
      this.tblData.collector_name = "";
      this.refresh();
    },

    close() {
      router.push({ name: "paylater.home" });
    }
  }
};
</script>